import React from 'react';
import InputMask from 'react-input-mask';

class InputCPF extends React.Component {
    render() {
      return <InputMask {...this.props} mask="999.999.999-99" maskChar="" className="form-control form-control-label" />;
    }
}

class InputCNPJ extends React.Component {
    render() {
      return <InputMask {...this.props} mask="99.999.999/9999-99" maskChar="" className="form-control form-control-label" />;
    }
}

class InputCEP extends React.Component {
    render() {
      return <InputMask {...this.props} mask="99999-999" maskChar="" className="form-control form-control-label" />;      
    }
}

class InputPLACA extends React.Component {
    render() {
      return <InputMask {...this.props} mask="aaa-****" maskChar="" className="form-control form-control-label" />;
    }
}

class InputTELEFONE extends React.Component {
    render() {
      return <InputMask {...this.props} mask="(99) 99999-9999" maskChar="" className="form-control form-control-label" />;
    }
}

export {    
    InputCPF,
    InputCNPJ,
    InputCEP,
    InputPLACA,
    InputTELEFONE    
};